import React, { useEffect, useState } from "react";
import cn from "classnames";
import { WidthContainer, Button, ChatAnimation, ChatWidget } from "~components";
import { GatsbyImage } from "gatsby-plugin-image";
import { useAppContext } from "~hooks";
import { useInView } from "react-intersection-observer";
import * as headerStyles from "~components/Common/Header/styles.module.scss";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Atf component that renders at Mobile viewwidths
 *
 * @return {node}
 */

const AtfMobile = ({ data, initialSlideIndex }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(initialSlideIndex);

  const currentSlide = data.slides[currentSlideIndex];

  const { setPrimaryColor, primaryColor, globalSettings } = useAppContext();

  const { ref, inView } = useInView({
    threshold: 0.3
  });

  const goToNextSlide = () => {
    setCurrentSlideIndex((prev) =>
      prev === data.slides.length - 1 ? 0 : prev + 1
    );
  };

  useEffect(() => {
    setPrimaryColor(currentSlide.themeColor.hex);
  }, [currentSlide]);

  const textWidget = currentSlide.mobileTextWidget;

  const BANNER_HEIGHT = headerStyles.bannerHeight;

  return (
    <div
      className={styles.container}
      ref={ref}
      style={{
        minHeight: globalSettings?.bannerText
          ? `calc(90vh - ${BANNER_HEIGHT})`
          : `90vh`
      }}
    >
      {/* Background Image */}
      {data.slides.map((slide, i) => (
        <GatsbyImage
          key={i}
          image={slide.backgroundImage.asset.gatsbyImageData}
          alt={slide.backgroundImage.asset.altText || ``}
          style={{
            position: `absolute`,
            inset: 0,
            top: 0,
            transition: `opacity 0.8s`,
            opacity: i === currentSlideIndex ? 1 : 0
          }}
        />
      ))}

      {/* Content */}
      <div className={styles.contrastOverlay} />
      <WidthContainer>
        <div
          className={styles.contentContainer}
          style={{ color: primaryColor }}
        >
          <h1 key={currentSlide} className={cn(`d2`, styles.faceText)}>
            Face {currentSlide.faceText}
          </h1>
          <p className={cn(`b1`, styles.text)}>{data.text}</p>
          <Button to="/products" light color={primaryColor}>
            Shop Now
          </Button>
        </div>
        <div className={styles.chat}>
          <ChatAnimation
            goToNextSlide={goToNextSlide}
            isAtfInView={inView}
            key={currentSlideIndex} // Need this to retrigger animation
            messages={[
              <ChatWidget
                type={textWidget.type}
                sender={textWidget.sender}
                content={textWidget.messageText}
              />
            ]}
          />
        </div>
      </WidthContainer>
    </div>
  );
};

export default AtfMobile;
